import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CompanyService } from '../../../services/company.service';


@Component({
  selector: 'app-company-picker',
  templateUrl: './company-picker.component.html',
  styleUrls: ['./company-picker.component.scss']
})
export class CompanyPickerComponent implements OnInit, OnChanges {
  @Input() accountId: number;
  @Input() disable: boolean = false;
  @Input() _placeholder: string = 'All';
  @Input() triggerRefetch: boolean = false;
  @Output() onCompanyIdSet = new EventEmitter<number>();
  @Output() onCompanySet = new EventEmitter<any>();

  companyId: number;
  companys = [];
  companyName: string;
  basePlaceholder: string;
  constructor(private companyService: CompanyService) {
  }

  ngOnInit(): void {
    ////console.log(this.accountId);
 this.loadCompanies();
    //////console.log("_placeholder: " + this._placeholder)
  }
  loadCompanies() {
    this.companyService.getAll().then((companys) => {
      this.companys = companys;
      this.basePlaceholder = this._placeholder;
    });
  }
  ngOnChanges(changes: SimpleChanges): void {

    if (changes.accountId != null && changes.accountId.currentValue != null) {
      if (this.companyId != changes.accountId.currentValue != null)
        this.companyId = changes.accountId.currentValue;

      //console.log("coompany id chaged to: " + this.companyId);

      this.companyService.getAll().then((companys) => {
        this.companys = companys;
        if (this.companyId != undefined && this.companyId != null) {
          var company = this.companys.find(a => a.id == this.companyId);
          this._placeholder = company.name;
        }
      });
    }
    if (changes.triggerRefetch != null && changes.triggerRefetch.currentValue != null) {
      this.loadCompanies();
    }
  }

  onChanged(company) {
    if (company != null) {
      this.onCompanyIdSet.emit(company.id);
    } else {
      this._placeholder = this.basePlaceholder;
      this.onCompanyIdSet.emit(null);
    }
    this.onCompanySet.emit(company);
  }

}
